export const SITE_CONFIG = {
  // IMAGE_BASE_URL: "https://assets.vilvabusiness.com",
  // IMAGE_BASE_URL: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com",
  IMAGE_BASE_URL: "https://assets.vilvabusiness.com",

  // Country flag images (used by phone-number inputs). Served from the
  // vilvad2c.com config cache, not IMAGE_BASE_URL. This host is allow-listed
  // in public/_headers (img-src / connect-src).
  COUNTRY_FLAG_BASE_URL: "https://cache.vilvad2c.com/config/countries/",

  // Backend API base URL. Set NEXT_PUBLIC_APIURL in .env.local (gitignored)
  // to override per environment (UAT / production). Falls back to UAT.
  API_BASE_URL:
    process.env.NEXT_PUBLIC_APIURL || "https://clientconnect.vilvabusiness.com/api",

  // ---- Analytics ids -------------------------------------------------------
  // All overridable per environment. None of these are secrets — every one of
  // them is visible in the page source of any site that uses them.
  //
  // The Meta pixel deliberately has NO fallback: empty disables it entirely
  // (no script, no beacon, trackEvent() no-ops), so a staging deploy that
  // forgets the variable cannot pollute production conversion data.
  META_PIXEL_ID: process.env.NEXT_PUBLIC_META_PIXEL_ID || "",

  // These three DO fall back to the live production values. They have been
  // hardcoded and working for a long time, so defaulting to empty would mean a
  // forgotten env var silently kills all analytics — a worse failure than a
  // staging deploy reporting into production.
  GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_ID || "G-NQ7K04MECW",
  LINKEDIN_PARTNER_ID: process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID || "8471660",
  CLARITY_PROJECT_ID: process.env.NEXT_PUBLIC_CLARITY_ID || "s3xl68peiu",
};

// Note: STATS_WORKER_URL (the Cloudflare Worker at repo root: wrangler.toml +
// worker.js) is intentionally NOT part of SITE_CONFIG — it's read directly
// from process.env by scripts/fetch-stats.mjs at build time only. No
// component or page ever calls it, so it doesn't need to be app config.